export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7636.1f98d283.jpg";